import React from "react";
import IBAMATable from "./IBAMATable/IBAMATable";

export default function IBAMACard(props) {
    const { ibama_data } = props
    const hasSource = Object.keys(ibama_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                IBAMA - Match encontrado
            </p>
            <IBAMATable ibama_data={ibama_data.source} />
        </div>
    )
}
